export default __webpack_public_path__ + "static/media/icon.a83c633a.svg";